import { ArticleParagraph2, Responsive, TDeviceType, Button } from '@cian/ui-kit';
import * as style from './Header.css';
import { Link } from 'react-scroll';
import { NAV_LINKS } from 'shared/constants/navLinks';
import clsx from 'clsx';
import { Overlay } from '../Overlay';

interface IHeaderProps {
  device: TDeviceType;
  onOpenMenu: VoidFunction;
  isOpen: boolean;
  menuRef: React.RefObject<HTMLDivElement>;
  onChangeModalVisible: VoidFunction;
}

export const Header: React.FC<IHeaderProps> = ({ device, onOpenMenu, isOpen, menuRef, onChangeModalVisible }) => {
  return (
    <div
      className={clsx(
        style['container'],
        device === 'tablet' && style['container-tablet'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['logo']} />
      <Responsive desktop>
        <div className={style['nav']}>
          {NAV_LINKS.map(({ id, scrollTo, title }) => (
            <Link key={id} to={scrollTo} offset={-100} smooth={true}>
              <ArticleParagraph2 fontWeight="700">{title}</ArticleParagraph2>
            </Link>
          ))}
        </div>
        <div className={style['button']}>
          <Button onClick={onChangeModalVisible}>Сдать квартиру</Button>
        </div>
      </Responsive>
      <Responsive tablet phone>
        <div className={style['burger-container']}>
          <div data-name="Burger" className={style['burger']} onClick={onOpenMenu} />
          <Overlay isOpen={isOpen} onClose={onOpenMenu} outside>
            <div ref={menuRef} className={clsx(style['burger-menu'], isOpen && style['open'])}>
              <div data-name="CloseBurger" className={style['close-btn']} onClick={onOpenMenu} />
              <div className={style['nav-list']}>
                {NAV_LINKS.map(({ id, scrollTo, title }) => (
                  <div key={id} className={style['nav-item']}>
                    <Link to={scrollTo} onClick={onOpenMenu} offset={-100} smooth={true}>
                      <ArticleParagraph2 fontWeight="700">{title}</ArticleParagraph2>
                    </Link>
                  </div>
                ))}
              </div>
              <div className={style['button']}>
                <Button onClick={onChangeModalVisible}>Сдать квартиру</Button>
              </div>
            </div>
          </Overlay>
        </div>
      </Responsive>
    </div>
  );
};
